import { gql } from "../__generated__/gql";

gql(`
    fragment SalaryFields on Salary {
        id
        yearMonth
        year
        netAmount
        month
        paidAt
        grossAmount
        salaryAsset {
            ...AssetFields
        }
        missionsInfo {
            ...MissionInfoFields
        }
    }
`);

export const FIND_MY_SALARIES = gql(`
    query FindMySalaries {
        findMySalaries {
            count
            elements {
                ...SalaryFields
            }
        }
    }
`);

export const GET_SALARY_DETAILS = gql(`
    query GetSalaryDetails(
        $cctEditionId: String!
        $cctDetailsValues: [CCTDetailsFieldValueInput!]
        $workerProfileId: String!
        $requestedSalaryType: SalaryType
        $requestedSalary: Int
        $vacationDays: Int
        $has13thSalary: Boolean
        $earningType: EarningType
        $workingTimeClassicSpec: WorkingTimeClassicInput!
        $hoursPerWeekFullTime: Decimal
        $laaActivityType: LaaActivityType
        $ijmGroupId: String
    ) {
        getSalaryDetails(
            cctEditionId: $cctEditionId
            cctDetailsValues: $cctDetailsValues
            workerProfileId: $workerProfileId
            requestedSalaryType: $requestedSalaryType
            requestedSalary: $requestedSalary
            vacationDays: $vacationDays
            has13thSalary: $has13thSalary
            earningType: $earningType
            workingTimeClassicSpec: $workingTimeClassicSpec
            hoursPerWeekFullTime: $hoursPerWeekFullTime
            laaActivityType: $laaActivityType
            ijmGroupId: $ijmGroupId
        ) {
            requestedSalary
            requestedSalaryType
            baseSalary
            netSalary
            grossSalary
            invoiceSalary
            totalCompensation
            vacationCompensation
            publicHolidaysCompensation
            thirteenMonthCompensation
            totalWorkerDeductions
            lseMargin
            workerDeductions {
                title
                quantity
                rate
                amount
            }
            totalClientDeductions
            clientDeductions {
                title
                quantity
                rate
                amount
            }
            vacationDays
            has13thSalary
            minBaseSalary
            minGrossSalary
            minNetSalary
            minInvoiceSalary
            mandatory13thMonth
            minVacationDays
            clientMissionFeesRate
        }
    }
`);

export const GET_SALARY_FORECAST = gql(`
    query GetSalaryForecast(
        $nbMonths: Int
        $monthYear: Date!
        $netSalary: Int!
        $grossSalary: Int!
        $invoiceSalary: Int!
        $earningType: EarningType!
        $contractStartDate: Date!
        $workingTimeClassicSpec: WorkingTimeClassicInput!
        $contractEndDate: Date
        $hoursPerWeekFullTime: Float!
        $workingAddressStateCode: String
        $fees: [MissionFeeInput!]!
        $deductions: [MissionDeductionInput!]!
    ) {
        getSalaryForecast(
            nbMonths: $nbMonths
            monthYear: $monthYear
            netSalary: $netSalary
            grossSalary: $grossSalary
            invoiceSalary: $invoiceSalary
            earningType: $earningType
            contractStartDate: $contractStartDate
            workingTimeClassicSpec: $workingTimeClassicSpec
            contractEndDate: $contractEndDate
            hoursPerWeekFullTime: $hoursPerWeekFullTime
            workingAddressStateCode: $workingAddressStateCode
            fees: $fees
            deductions: $deductions
        ) {
            monthYear
            monthStartDate
            monthEndDate
            grossSalary
            netSalary
            invoiceSalary
            includedFeesAmount
            includedDeductionsAmount
            includedClientDeductionsAmount
            includedWorkerDeductionsAmount
        }
    }
`);

export const GET_SALARY = gql(`
    query GetSalary($salaryId: ID!) {
        getSalary(salaryId: $salaryId) {
            ...SalaryFields
        }
    }
`);
